import { useMutation, useQueryClient } from "react-query";
import { addGroup } from "api/services/groups";
import { EGroupsQueryKeys } from "api/endpoints/groups";
import { logError } from "utils/notifications";
import { TAddGroup, TGroup } from "types/api/groups";
import { TApiError } from "types/api/error";

export const useAddGroup = () => {
  const queryClient = useQueryClient();
  return useMutation<TGroup, TApiError, TAddGroup>(addGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries(EGroupsQueryKeys.getGroups);
    },
    onError: (error) => logError({ error }),
    retry: false,
  });
};
